<template>
  <div class="attachment-container">
    <div v-if="isDragging" class="drag-overlay"></div>
    <div
      class="attachment-field d-flex flex-column align-items-center justify-content-center gap-3"
      @drop="handleDrop"
      @dragover="handleDragOver"
      @dragleave="handleDragLeave"
    >
      <div
        v-if="fileName"
        class="attachment-field__file-attached d-flex flex-column align-items-center justify-content-center gap-2"
      >
        <img src="@/assets/images/xls-icon.png" width="43" alt="xls-icon" />
        <p>{{ fileName }}</p>

        <b-spinner v-if="isLoading" />
      </div>

      <div v-else class="attachment-field__empty-state">
        <p>{{ $t('global.importData.chooseFile') }}</p>
        <p>{{ $t('global.importData.maksFile2MB') }}</p>
      </div>

      <McButton
        :text="$t('global.importData.selectFile')"
        variant="secondary"
        @click="handleLoadFile"
        :disabled="isLoading"
      />

      <input
        type="file"
        ref="file-input-ref"
        :accept="fileAccepted.join(', ')"
        @change="handleFileChanged"
        hidden
      />
    </div>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  emits: ['update:isDisableNextBtn'],
  data() {
    return {
      isLoading: false,
      isDragging: false,
      fileName: '',
      fileSize: null,
      fileType: null,
      fileId: null,
      file: undefined,
    }
  },
  computed: {
    fileAccepted() {
      return [
        '.csv',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/wps-office.xlsx',
      ]
    },
  },
  methods: {
    async HandleProcessFile() {
      this.$emit('update:isDisableNextBtn', true)

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = (error) => reject(error)
        })

      const files = {
        filebase64: (await toBase64(this.file)).split(',')[1],
        filename: this.fileName,
        filesize: this.fileSize,
        filetype: this.fileType,
      }

      this.$store.commit('maintenance/SET_FILE', files)

      this.$emit('update:isDisableNextBtn', false)

      this.redirectToProcessFile()
    },
    redirectToProcessFile() {
      this.$router.push({
        name: 'Service Schedule Import Detail',
      })
    },
    handleLoadFile() {
      if (this.isLoading) {
        this.$mcToast.warning('Mohon Tunggu')
        return
      }

      this.$refs['file-input-ref'].click()
    },
    handleDragOver(event) {
      event.preventDefault()
      this.isDragging = true
    },
    handleDragLeave() {
      this.isDragging = false
    },
    handleDrop(event) {
      event.preventDefault()

      this.isLoading = true
      this.file = event.dataTransfer.files[0]

      this.isDragging = false
      this.uploadFile()
    },
    resetInputFile(event) {
      this.fileName = ''
      this.fileSize = null
      this.file = undefined

      if (event) {
        event.target.value = ''
      }

      this.isLoading = false
    },
    handleFileChanged(event) {
      this.isLoading = true

      const [file] = event.target.files
      if (!file) {
        this.isLoading = false
        return
      }

      this.file = file
      this.uploadFile(event)
    },
    async uploadFile(event = undefined) {
      if (!this.fileAccepted.includes(this.file.type)) {
        this.$mcToast.error('Unggah gagal. Format file tidak sesuai.')

        this.resetInputFile(event)
        return
      }

      let fileSize = this.file.size
      const MAX_FILE_SIZE = 1024 * 1024 * 2 // 2MB
      if (fileSize > MAX_FILE_SIZE) {
        this.$mcToast.error('Unggah gagal. Ukuran file melebihi batas ketentuan.')

        this.resetInputFile(event)
        return
      }

      this.fileName = this.file.name
      this.fileType = this.file.type
      fileSize = this.file.size / 1024 / 1024
      this.fileSize = fileSize.toFixed(2)

      this.$emit('update:isDisableNextBtn', false)

      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.attachment-container {
  position: relative;
  width: 100%;
  height: 100%;

  .attachment-field {
    border: 2px dashed $mep-primary-100;
    border-radius: 4px;
    width: 100%;
    height: 100%;

    p {
      line-height: 20px;
      margin: 0;
      text-align: center;
    }

    &__empty-state {
      color: $mep-color-text-300;
    }

    &__file-attached {
      width: 75%;
      text-align: center;
      font-weight: 600;
    }

    &__progress-bar {
      width: 100%;
    }
  }
}
</style>
